import { render, staticRenderFns } from "./Assinante.vue?vue&type=template&id=5aa2f0a9&"
import script from "./Assinante.vue?vue&type=script&lang=js&"
export * from "./Assinante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports